"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const tokens = __importStar(require("@trp-rps-rps-shared-web/rps-shared-web-styles"));
const StyledErrorContainer = styled_components_1.default.div `
  background-color: ${tokens.ColorFunctionalGold100};
  color: ${tokens.ColorGrey900};
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  line-height: 1.38;
  padding: 16px;
`;
class ErrorCmponent extends react_1.Component {
    render() {
        const { message } = this.props;
        return react_1.default.createElement(StyledErrorContainer, { tabIndex: 0 }, message);
    }
}
exports.default = ErrorCmponent;
//# sourceMappingURL=ErrorComponent.js.map